module.exports = __webpack_public_path__ + "img/employees.8038830d.png";